import { render, staticRenderFns } from "./TopicsGrid.vue?vue&type=template&id=20f3b35e"
import script from "./TopicsGrid.vue?vue&type=script&lang=js"
export * from "./TopicsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports